import React, { useEffect, useState } from 'react';

import { useContingencyEvents } from '../../../hooks/dte/useContingencyEvents';
import { getContingencyEventFilters } from '../../../constants/dte/contingency/getContingencyEventFilters';
import { getContingencyEventTableActions } from '../../../features/contingency/getContingencyEventTableActions';
import { contingencyEventColumns } from '../../../constants/dte/contingencyEventColumns';

import AdvancedRecordTable from '../../../components/Tables/advancedRecord/AdvancedRecordTable';
import ContingencyEventDetailModal from './ContingencyEventDetailModal';
import { contingencyStatusDropdown } from '../../../constants/dte/contingency/contingencyStatusDropdown';
import { fakeCreatedByDropdown } from '../../../constants/dte/contingency/fakeCreatedByDropdown';

const ContingencyHistory: React.FC = () => {
  const {
    list,
    paginator,
    pageSize,
    updatePageSize,
    handlerGetFilteredEvents,
    clearList,

    detail,
    detailLoaded,
    openDetail,
    refreshDetail,
    detailError,
    closeDetail,
  } = useContingencyEvents();

  const [filters, setFilters] = useState({});

  const handleFilterChange = (newFilters: any) => {
    setFilters(newFilters);
    handlerGetFilteredEvents(newFilters, 0, pageSize);
  };

  const handlePageChange = (page: number) => {
    handlerGetFilteredEvents(filters, page, pageSize);
  };

  const handlePageSizeChange = (size: number) => {
    updatePageSize(size);
    handlerGetFilteredEvents(filters, 0, size);
  };

  useEffect(() => {
    handlerGetFilteredEvents({}, 0, pageSize);
  }, []);

  useEffect(() => {
    if (!detailLoaded || !detail?.id || detail.status === 'FINISHED') return;

    let cancelled = false;
    let timer: ReturnType<typeof setTimeout>;
    const poll = async () => {
      await refreshDetail(detail.id);
      if (!cancelled) timer = setTimeout(poll, 7000);
    };
    timer = setTimeout(poll, 7000);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [detailLoaded, detail?.id, detail?.status, refreshDetail]);

  const filtersConfig = getContingencyEventFilters(
    contingencyStatusDropdown,
    fakeCreatedByDropdown
  );

  const getActions = (row: any) =>
    getContingencyEventTableActions({
      row,
      handlers: {
        onView: (id: number) => openDetail(id), // ✅ Abrimos modal
      },
    });

  return (
    <>
      <AdvancedRecordTable
        columns={contingencyEventColumns}
        data={list}
        paginator={paginator}
        pageSize={pageSize}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        filtersConfig={filtersConfig}
        onFilterChange={handleFilterChange}
        onResetFilters={clearList}
        getActions={getActions}
        noDataMessage="No hay eventos de contingencia registrados."
        url="/hacienda/contingency-events"
      />

      {/* ✅ Modal de detalle */}
      <ContingencyEventDetailModal
        isOpen={detailLoaded}
        data={detail}
        errorMessage={detailError}
        onClose={closeDetail}
      />
    </>
  );
};

export default ContingencyHistory;
